import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { archiveIndex } from '../../features/dashboard/ArchiveSlice';
import Loading from '../../Loading';
import Header from './Header';
import { Calendar } from "react-multi-date-picker";
import DatePicker,{DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import DataTable, { ExpanderComponentProps } from 'react-data-table-component';
import Broadcast from './Broadcast';
import * as Icon from 'react-feather';
import $ from 'jquery'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import * as moment from 'jalali-moment';


function ArchiveIndex () {
    const columns = [
        {
            name: '#',
            cell: (row, index) => <div className='rahpardaznet-border'>{index + 1} </div>,

        },
        {

            name: 'نام انبار',
            cell: row => <div className='rahpardaznet-border'>{row.name}</div>
        },
        {

            name: 'نام مدیر انبار',
            sortable: true,
            cell: row => <div className='rahpardaznet-border'>{row.manager}</div>
        },
        {
            name: 'کد انبار',
            cell: row => <div className='rahpardaznet-border'><span>{row.code}</span></div>,
        },
        {
            name: 'شماره تلفن انبار',
            cell: row => <div className='rahpardaznet-border'><span>{row.phone}</span></div>,
        },
        {
            name: 'آدرس انبار',
            cell: row => <div className='rahpardaznet-border'><span>{row.address}</span></div>,
        },
        {
            name: 'وضعیت',
            cell: row => <div className='rahpardaznet-border'><span className='text-success'>فعال</span></div>
        },
        {
            name: 'تاریخ ایجاد',
            cell: row => <div className="rahpardaznet-border">{moment(row.created_at).locale('fa').format('YYYY/MM/DD HH:mm:ss')}</div>
        },
        {
            name: 'عملیات',
            cell: row => <div className='rahpardaznet-table-btn'>
                <span>
                    <Link 
                        to={`/dashboard/archive/section/one/index/${row.id}`} 
                        className='rahpardaznet-icon-table'
                        data-tooltip-id={"tooltip-show-"+row.id}
                        data-tooltip-content='نمایش بخش های اصلی'
                        data-tooltip-place="top"
                    >
                        <i className="fa-regular fa-eye fa-fw"></i>
                        
                    </Link>
                    <Tooltip id={"tooltip-show-"+row.id} style={{ backgroundColor: "#767676", color: "#fff" }} />
                </span>
            </div>
        },
    ];
    const [page, setPage] = useState(1);
    const countPerPage = 20;
    const dispatch = useDispatch()
    const token = localStorage.getItem('token')
    const date = new DateObject({ calendar: persian, locale: persian_fa })
    const { archives, loading, rahpardaznetLoading } = useSelector(state => state.archive)
    const getUserList = async (search = pinCode, pageNumber = page) => {
        console.log('aaa');
        const data = {
            'pageNumber' : pageNumber,
            'countPerPage' : countPerPage,
            'search' : search
        }
            dispatch(archiveIndex(data))


        
    }
    function searchByDataTable(event) {
        let delayTimeOutFunction;
        delayTimeOutFunction = setTimeout(() => {

            getUserList(event.target.value);


        }, 3000); // denounce delay

        return () => clearTimeout(delayTimeOutFunction);

    }
    const [pinCode, setPinCode] = useState("");
    useEffect(() => {
        getUserList()
    }, []);

    const rahkarpardaznet_search_datatable = (e) => {

        e.preventDefault();
        setPage(1);

        $('#pagination-first-page').trigger('click');
        getUserList(pinCode, 1);
    }

    const handlePageChange = (page) => {
        setPage(page);
        getUserList('', page);
    };

    
    useEffect(() => {
        if(rahpardaznetLoading){
            $('.dlUCce').addClass('loading');
        }else{
            $('.dlUCce').removeClass('loading');
        }
    }, [rahpardaznetLoading])

   

    return (
        <>
        { loading ? ( <Loading /> ) : ''}
        <Broadcast title={'مدیریت انبارها'} />
                <div className='row g-2 pr-3 pl-3 pb-4'>

                    <div className="App">
                        <form  onSubmit={rahkarpardaznet_search_datatable} className="rk-search-bar">
                            <input type="text" id="" placeholder='جستجو کنید' onChange={(event) => setPinCode(event.target.value)} />
                            <button type="submit"><Icon.Search /></button>

                        </form>
                        <DataTable
                            title=""
                            columns={columns}
                            data={(typeof archives == 'object'  ) ? archives.data : []}
                            className='rahpardaznet-table-user'
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={(typeof archives == 'object' ) ? archives.total : []}
                            paginationPerPage={countPerPage}
                            paginationComponentOptions={{
                                noRowsPerPage: true
                            }}
                            onChangePage={handlePageChange}
                        />
                    </div>


                </div>
        
        </>
    )
}

export default ArchiveIndex;